module.exports = __webpack_public_path__ + "PERUVIANhome-7.6c300c7b.png";